__turbopack_context__.v({
  "body": "ReferenceCards-module-scss-module__XoBjoa__body",
  "collection": "ReferenceCards-module-scss-module__XoBjoa__collection",
  "intro": "ReferenceCards-module-scss-module__XoBjoa__intro",
  "introNextToCards": "ReferenceCards-module-scss-module__XoBjoa__introNextToCards",
  "items": "ReferenceCards-module-scss-module__XoBjoa__items",
  "title": "ReferenceCards-module-scss-module__XoBjoa__title",
});
